import {StockInformationModel} from "../domain/stockInformationModel";

type BuiltToOrderModelType = Pick<
    StockInformationModel,
    "leadIn" | "actualLeadTime" | "artworkLeadTime" | "customArtwork"
>;

export class BuiltToOrderModel {
    private _model: BuiltToOrderModelType;

    constructor(model: BuiltToOrderModelType) {
        this._model = model;
    }

    get showSubtitle() {
        return this._model.leadIn > 0;
    }

    get subtitle() {
        const shippingLeadTimeMessage = `Ships in approximately ${
            this._model.actualLeadTime
        } business day${this._model.actualLeadTime > 1 ? "s" : ""}`;
        const artworkLeadTimeMessage = this._model.customArtwork
            ? "; excludes artwork approval processing time of " +
            this._model.artworkLeadTime +
            " business days"
            : "";
        return `${shippingLeadTimeMessage}${artworkLeadTimeMessage}`;
    }

    static create(model: StockInformationModel) {
        return new BuiltToOrderModel(model);
    }
}
